import LoadingLottie from "@/assets/lotties/loading.json";
import type { LottieRefCurrentProps } from "lottie-react";
import dynamic from "next/dynamic";
import { useRef } from "react";

const Lottie = dynamic(() => import("lottie-react"), { ssr: false }) as any;

const Loader = () => {
  const lottieRef = useRef<LottieRefCurrentProps>(null);

  return (
    <div className="cursor-pointer">
      <Lottie
        lottieRef={lottieRef}
        style={{
          width: "64px",
          height: "64px",
        }}
        loop={true}
        autoplay={true}
        animationData={LoadingLottie}
      />
    </div>
  );
};

export default Loader;
